function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 10.5a3.5 3.5 0 117 0V15h4v-4.5a3.5 3.5 0 117 0v.337A3.5 3.5 0 0130 14v1h1a1 1 0 110 2h-1v1a3.5 3.5 0 01-5 3.163v.337a3.5 3.5 0 11-7 0V17h-4v4.5a3.5 3.5 0 11-7 0v-.337A3.5 3.5 0 012 18v-1H1a1 1 0 110-2h1v-1a3.5 3.5 0 015-3.163V10.5zM4 18a1.5 1.5 0 003 0v-4a1.5 1.5 0 00-3 0v4zm8-7.5a1.5 1.5 0 00-3 0v11a1.5 1.5 0 003 0v-11zm8 11a1.5 1.5 0 003 0v-11a1.5 1.5 0 00-3 0v11zm8-7.5a1.5 1.5 0 00-3 0v4a1.5 1.5 0 003 0v-4z",
  fill: "currentColor"
})));